// SPDX-License-Identifier: AGPL-3.0-or-later

import {GuildFeatures} from '@fluxer/constants/src/GuildConstants';
import type {I18n, MessageDescriptor} from '@lingui/core';
import {msg} from '@lingui/core/macro';

const GUILD_BOOST_FEATURE_LABELS: Partial<Record<string, MessageDescriptor>> = {
	[GuildFeatures.AUDIO_BITRATE_128_KBPS]: msg({
		message: '128 kbps voice quality',
		context: 'guild-boost',
		comment: 'Guild boost perk label for 128 kbps voice channels.',
	}),
	[GuildFeatures.AUDIO_BITRATE_256_KBPS]: msg({
		message: '256 kbps voice quality',
		context: 'guild-boost',
		comment: 'Guild boost perk label for 256 kbps voice channels.',
	}),
	[GuildFeatures.AUDIO_BITRATE_384_KBPS]: msg({
		message: '384 kbps voice quality',
		context: 'guild-boost',
		comment: 'Guild boost perk label for maximum voice quality.',
	}),
	[GuildFeatures.ANIMATED_ICON]: msg({
		message: 'Animated community icon',
		context: 'guild-boost',
		comment: 'Guild boost perk label for animated guild icons.',
	}),
	[GuildFeatures.BANNER]: msg({
		message: 'Community banner',
		context: 'guild-boost',
		comment: 'Guild boost perk label for guild banner uploads.',
	}),
	[GuildFeatures.INVITE_SPLASH]: msg({
		message: 'Invite splash',
		context: 'guild-boost',
		comment: 'Guild boost perk label for invite splash artwork.',
	}),
	[GuildFeatures.ANIMATED_BANNER]: msg({
		message: 'Animated banner',
		context: 'guild-boost',
		comment: 'Guild boost perk label for animated guild banners.',
	}),
	[GuildFeatures.VANITY_URL]: msg({
		message: 'Vanity invite URL',
		context: 'guild-boost',
		comment: 'Guild boost perk label for custom vanity invite links.',
	}),
	[GuildFeatures.SERVER_TAG]: msg({
		message: 'Server tag',
		context: 'guild-boost',
		comment: 'Guild boost perk label for the community server tag badge.',
	}),
};

const GUILD_BOOST_STICKER_SLOTS_DESCRIPTOR = msg({
	message: '{count, plural, one {# sticker slot} other {# sticker slots}}',
	context: 'guild-boost',
	comment: 'Guild boost perk line for sticker slot capacity. count is the sticker limit number.',
});

export function getGuildBoostFeatureLabel(i18n: I18n, feature: string): string {
	const descriptor = GUILD_BOOST_FEATURE_LABELS[feature];
	return descriptor ? i18n._(descriptor) : feature;
}

export function getGuildBoostStickerSlotsLabel(i18n: I18n, count: number): string {
	return i18n._(GUILD_BOOST_STICKER_SLOTS_DESCRIPTOR, {count});
}
